"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _generalStore = require("general-store");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _MeetingsActions = require("./MeetingsActions");

var MEETINGS_USER_KEY = 'meetingsUser';
var MEETINGS_LINKS_KEY = 'meetingsLinks';

var _default = (0, _generalStore.defineFactory)().defineName('MeetingsStore').defineGetInitialState(_immutable.Map).defineGet(function (state) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!state.has(MEETINGS_USER_KEY)) {
    (0, _MeetingsActions.fetchMeetingsUser)();
  }

  if (!options.onlyUser && !state.has(MEETINGS_LINKS_KEY)) {
    (0, _MeetingsActions.fetchMeetingsLinks)();
  }

  return state;
}).defineResponseTo(_ActionTypes.MEETINGS_USER_FETCH_SUCCEEDED, function (state, user) {
  return state.set(MEETINGS_USER_KEY, user);
}).defineResponseTo(_ActionTypes.MEETINGS_USER_UNAVAILABLE, function (state) {
  return state.set(MEETINGS_USER_KEY, -1);
}).defineResponseTo(_ActionTypes.MEETINGS_LINKS_FETCH_SUCCEEDED, function (state, links) {
  return state.set(MEETINGS_LINKS_KEY, links);
}).defineResponseTo(_ActionTypes.MEETINGS_LINKS_FETCH_FAILED, function (state) {
  return state.set(MEETINGS_LINKS_KEY, -1);
}).register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;